<template>
  <b-modal 
    v-model="modalShow" 
    id="modal-image-detail" 
    @hidden="$router.push('/')"
    hide-footer
  >
    <div slot="modal-header">
      <!-- <h5 class="modal-title"></h5> -->
      <button 
        type="button" 
        class="close" 
        data-dismiss="modal"
        aria-label="Close"
        @click="modalShow=false"
      >
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div v-if="photo">
      <div class="thumbnails">
        <!-- Square thumbnails -->
        <div class="row-square">
          <div 
            v-for="(size, index) in previewSizes"
            :key="index"
            :class="'thumbnail ' + size"
          >
            <div class="aspect-1x1 child-crop">
              <img :src="imageURL" class="rounded border border-light">
            </div>
          </div>
        </div>
        <!-- Rounded thumbnails -->
        <div class="row-circle">
          <div 
            v-for="(size, index) in previewSizes"
            :key="index"
            :class="'thumbnail ' + size"
          >
            <div class="aspect-1x1 child-crop">
              <img :src="imageURL" class="rounded-circle border border-light">
            </div>
          </div>
        </div>
      </div>
      <h1 v-if="photo.title" class="title">
        {{ photo.title.rendered }}
      </h1>
      <div class="meta">
        <div class="credit">
          <p v-if="photo.acf.photographer[0]">Photo by: <span class="photographer">{{photo.acf.photographer[0].post_title}}</span></p>
          <p v-if="photo.acf.stock_site[0]">Source: <span class="site"><a :href="photo.acf.original_url" target="_blank">{{photo.acf.stock_site[0].post_title}}</a></span></p>
        </div>
        <div class="license">
          <strong>CC0 License</strong>
          <ul>
            <li>Free for personal and commercial use</li>
            <li>No attribution required</li>
          </ul>
          <a href="https://creativecommons.org/publicdomain/zero/1.0/" target="_blank">Learn more about the license</a>
        </div>
        <div class="ctas">
          <a :href="imageURL" class="btn primary download" rel="nofollow" target="_blank" download>
            <b class="icon-download-white"></b>Free Download
          </a>
          <!-- <a href="#" class="">Add to Collection</a> -->
        </div>
      </div>
    </div>
    
  </b-modal>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import { ModalPlugin } from 'bootstrap-vue'

Vue.use(ModalPlugin)

export default {
  data () {
    return {
      modalShow: this.$route.meta.showModal,
      photoID: this.$route.params.id,
      photo: null,
      photoIsLoading: false,
      previewSizes: ['xs', 'sm', 'md', 'lg']
    }
  },
  computed: {
    apiURL: function () {
      return this.$store.state.baseURL + 'wp-json/wp/v2/photos/'+this.photoID+'?_embed'
    },
    imageURL: function () {
      let url = null

      if (this.photo != null) {
        if (this.photo._embedded["wp:featuredmedia"][0].media_details.sizes.large != null) {
          url = this.photo._embedded["wp:featuredmedia"][0].media_details.sizes.large.source_url
        } else {
          url = this.photo._embedded["wp:featuredmedia"][0].media_details.sizes.full.source_url
        }
      }
      return url
    }
  },
  methods: {
    fetchPhoto: function () {
      let that = this
      this.photoIsLoading = true
      axios
        .get(this.apiURL)
        .then(function(response) {
          const data = response.data
          that.photo = data
          that.photoIsLoading = false
        })
    },
  },
  watch: {
    '$route.meta' ({showModal}) {
      this.modalShow = showModal
    },
  },
  mounted () {
    this.fetchPhoto()
  }
}
</script>